module.exports = __webpack_public_path__ + "img/fossils.0c036168.svg";